import React, { useEffect, useState, useMemo } from 'react';
import Papa from 'papaparse';
// import PropTypes from 'prop-types';

const SubPics = ({ currentStyle, url, onImageClick, color }) => {
  const [data, setData] = useState([]);
  const [currentItem, setCurrentItem] = useState(null);

  useEffect(() => {
    const fetchCSV = async () => {
      try {
        const response = await fetch(url);
        const csvText = await response.text();
        const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
        setData(parsed.data);
      } catch (err) {
        console.error('Error loading CSV:', err);
      }
    };
    fetchCSV();
  }, [url]);

  useEffect(() => {
    if (data.length > 0) {
      const found = data.find(item =>
        item.Style?.trim() === currentStyle?.trim() &&
        item.Color?.trim() === color?.trim()
      );
      setCurrentItem(found || null);
    }
  }, [data, currentStyle, color]);

  const uniqueImages = useMemo(() => {
    if (!currentItem) return [];
    const images = [
      currentItem.FRONT_FLAT,
      currentItem.BACK_FLAT,
      currentItem.FRONT_MODEL,
      currentItem.BACK_MODEL,
      currentItem.SIDE_MODEL,
      currentItem.THREE_Q_MODEL,
      currentItem.model,
      currentItem.back,
      currentItem.front,
      currentItem.ImageSrc
    ]
      .filter(Boolean)
      .map(img => img.trim());
    return [...new Set(images)];
  }, [currentItem]);

  if (!currentItem || uniqueImages.length === 0) {
    return 
    <></>
   
  }

  return (
    <div style={{ display: 'flex', gap: '8px', margin: '1rem 0' }}>
      {uniqueImages.map((imgUrl, idx) => (
        <img
          key={idx}
          src={imgUrl}
          alt={`${currentStyle} thumbnail ${idx + 1}`}
          style={{
            width: 58,
            height: 66,
            borderRadius: 4,
            cursor: 'pointer',
            border: '3px solid #ccc',
            marginRight: '-2px',
          }}
          onClick={() => onImageClick?.(imgUrl)}
          onError={(e) => {
            e.target.src = '/images/placeholder.jpg';
          }}
        />
      ))}
    </div>
  );
};

// SubPics.propTypes = {
//   currentStyle: PropTypes.string.isRequired,
//   url: PropTypes.string.isRequired,
//   onImageClick: PropTypes.func,
//   color: PropTypes.string.isRequired,
// };

export default SubPics;
